import { defineRouting } from "next-intl/routing";
import { createNavigation } from "next-intl/navigation";
import { DEFAULT_LOCALE, LOCALES } from "./constants";

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: LOCALES,

  // Used when no locale matches
  defaultLocale: DEFAULT_LOCALE,
  localeDetection: true, // Automatically detect locale
  localePrefix: "as-needed", // Omits the locale prefix for the default locale,
  localeCookie: false // Do not use a cookie for locale detection
});

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
